import React from 'react'
import styled from '@emotion/styled'
import { font, spacing } from '@mobi/component-library/Theme/Common'
import emptyStateSvgAsset from './assets/feedEmptyState.png'
import bettableTipAsset from './assets/bettableTip.png'
import resultedTipAsset from './assets/resultedTip.png'
import ticketAsset from './assets/ticket.png'
import feedProfileEmptyState from './assets/feedProfileEmptyState.png'
import exploreFeedEmptyState from './assets/exploreFeedEmptyState.png'

export const EmptyMessage: React.FC<{
  title: string
  description: string
  messageType: 'feed' | 'bettable-tip' | 'non-bettable-tip' | 'tickets' | 'profile' | 'explore'
}> = ({ title, description, messageType }) => (
  <WrapperStyled data-testid='BetLoop.EmptyMessage'>
    {messageType === 'feed' && (
      <img src={emptyStateSvgAsset} width='334' height='275' role='presentation' />
    )}

    {messageType === 'bettable-tip' && (
      <img src={bettableTipAsset} width='231' height='135' role='presentation' />
    )}

    {messageType === 'non-bettable-tip' && (
      <img src={resultedTipAsset} width='231' height='135' role='presentation' />
    )}

    {messageType === 'tickets' && (
      <img src={ticketAsset} width='186' height='71' role='presentation' />
    )}

    {messageType === 'profile' && (
      <img src={feedProfileEmptyState} width='250' height='250' alt='Follow Me Feed Empty' />
    )}

    {messageType === 'explore' && (
      <img src={exploreFeedEmptyState} width='334' height='275' alt='Follow Me Feed Empty' />
    )}

    <div>{title}</div>

    <div>{description}</div>
  </WrapperStyled>
)

// =======
// Styles
// =======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  padding: `${spacing.lgx1} 0`,

  '> div:first-of-type': {
    marginTop: spacing.big,
    fontWeight: font.weight.semibold,
  },

  '> div:last-of-type': {
    maxWidth: '25rem',
    whiteSpace: 'pre-line',
  },
})
